export const Text = {
    baseStyle: {
        textStyle: 'm'
    }
};

//# sourceMappingURL=text.js.map